import { atomWithReset } from "jotai/utils";

export const isAddCommentModeActiveAtom = atomWithReset(false);
